export const BAG_AUDIT_CONSTANTS = {
	PHOTO_TYPE: 'LOAD' as const,
	APPLICATION_TYPE: 'mrf' as const,
	S3_PATH_PREFIX: 'trackable-assets/bag-audit',
	IMAGE_CONTENT_TYPE: 'image/jpeg',
	IMAGE_QUALITY: 0.8,
} as const;

export const BAG_AUDIT_ERRORS = {
	INVALID_BAG_STATE: 'INVALID_BAG_STATE',
	UPLOAD_URL_FAILED: 'UPLOAD_URL_FAILED',
	PHOTO_UPLOAD_FAILED: 'PHOTO_UPLOAD_FAILED',
	AUDIT_CREATION_FAILED: 'AUDIT_CREATION_FAILED',
	PHOTO_RECORD_FAILED: 'PHOTO_RECORD_FAILED',
	MISSING_REQUIRED_DATA: 'MISSING_REQUIRED_DATA',
} as const;

export type BagAuditPageType = 'SCAN' | 'FORM' | 'PHOTOS';

export type BagAuditError = (typeof BAG_AUDIT_ERRORS)[keyof typeof BAG_AUDIT_ERRORS];
